"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setRemoveMessageAction = exports.setMessageAction = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var uuid_1 = require("uuid");
var notificationMessages_model_1 = require("../models/notificationMessages.model");
var notificationMessagesSlice = (0, toolkit_1.createSlice)({
    name: 'notificationMessages',
    initialState: (0, notificationMessages_model_1.notificationMessagesStateFactory)(),
    reducers: {
        setMessageAction: function (state, action) {
            state.unshift(__assign(__assign({}, action.payload), { id: action.payload.id || (0, uuid_1.v4)() }));
        },
        setRemoveMessageAction: function (state) {
            state.slice(0, -1);
        },
    },
});
var actions = notificationMessagesSlice.actions, reducer = notificationMessagesSlice.reducer;
exports.setMessageAction = actions.setMessageAction, exports.setRemoveMessageAction = actions.setRemoveMessageAction;
__exportStar(require("../models/notificationMessages.model"), exports);
exports.default = reducer;
